export const allHistoryColumns = [
  {
    // id: "name",
    header: "name",
    accessorKey: "name",
    size: 150,
  },
  {
    header: "company",
    accessorKey: "company",
    size: 150,
  },
  {
    header: "email",
    accessorKey: "email",
    size: 150,
  },
  {
    header: "video",
    accessorKey: "videoTitle",
    size: 150,
  },
  {
    header: "date",
    accessorKey: "updatedAt",
    typeof: "date",
    cell: ({ getValue }) => {
      const date = new Date(getValue());
      return date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    size: 150,
  },
];
